/** CoStar.Api.ExternalAuthentication.ResetPasswordError */
export var ResetPasswordError;
(function (ResetPasswordError) {
    ResetPasswordError[ResetPasswordError["None"] = 0] = "None";
    ResetPasswordError[ResetPasswordError["PasswordLacksComplexity"] = 1] = "PasswordLacksComplexity";
    ResetPasswordError[ResetPasswordError["TokenIsInvalid"] = 2] = "TokenIsInvalid";
    ResetPasswordError[ResetPasswordError["EmailDoesNotExists"] = 3] = "EmailDoesNotExists";
})(ResetPasswordError || (ResetPasswordError = {}));
/** CoStar.Api.ExternalAuthentication.StatusErrorCode */
export var StatusErrorCode;
(function (StatusErrorCode) {
    StatusErrorCode[StatusErrorCode["None"] = 0] = "None";
    StatusErrorCode[StatusErrorCode["InternalError"] = 1] = "InternalError";
    StatusErrorCode[StatusErrorCode["UserNameTaken"] = 2] = "UserNameTaken";
    StatusErrorCode[StatusErrorCode["Other"] = 3] = "Other";
})(StatusErrorCode || (StatusErrorCode = {}));
import { ExternalLoginProviders } from "../../../CoStar/Api/AptsNet/MobileServices/ViewModels/index.js";
/** CoStar.Api.ExternalAuthentication.ExternalLoginProviders */
export { ExternalLoginProviders };
